import BzbsCampaign from "@/core/Campaign/service/BzbsCampaign"
import { CampaignConfigBuilder } from "@/core/Campaign/config/CampaignConfigModel"

export default function (states) {
    const loadCampaignDetail = function () {
        let builder = new CampaignConfigBuilder()
        builder.setCampaignId(states.query.campaignId)
        return new Promise((resolve, reject) => {
            // console.log(states.query.token)
            BzbsCampaign.apiGetCampaignDetail(builder.create(), states.query.token).subscribe({
                next: (res) => {
                    states.campaign = res
                    resolve(res)
                },
                error: (err) => {
                    states.campaign = null
                    reject(err)
                }
            });
        })
    }

    return {
        loadCampaignDetail
    }
}
